import { render, staticRenderFns } from "./PrintModeChooseFinishes.vue?vue&type=template&id=2984c4ad&scoped=true&"
import script from "./PrintModeChooseFinishes.vue?vue&type=script&lang=js&"
export * from "./PrintModeChooseFinishes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2984c4ad",
  null
  
)

export default component.exports